import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import LinkButton from '@atlaskit/button/link';

import { ConfluencePageSubType } from '@confluence/create-blank-fabric-page/entry-points/CreateBlankPageMutation.ts';
import { buildCreationLink } from '@confluence/create-blank-fabric-page/entry-points/createContentRouteUtils.ts';

type CreatePageButtonProps = {
	appearance: React.ComponentProps<typeof LinkButton>['appearance'];
	creationLinkSource: string;
	showCreateDocButton?: boolean;
	showCreateLivePageButton?: boolean;
};

const i18n = defineMessages({
	createPage: {
		id: 'home.home-views.create-page',
		defaultMessage: 'Create a page',
		description: 'Text of a button which, when clicked, creates a page',
	},
	createLivePage: {
		id: 'home.home-views.create-live-doc',
		defaultMessage: 'Create a live doc',
		description: 'Text of a button which, when clicked, creates a live page',
	},
	createDoc: {
		id: 'home.home-views.create-doc',
		defaultMessage: 'Create doc',
		description: 'Text of a button which, when clicked, creates a doc',
	},
});

export const CreatePageButton = ({
	appearance,
	creationLinkSource,
	showCreateDocButton,
	showCreateLivePageButton,
}: CreatePageButtonProps): React.JSX.Element => {
	const creationHref = buildCreationLink({
		contentType: 'page',
		source: creationLinkSource,
		withFallback: true,
		subType: ConfluencePageSubType.LIVE,
	});
	let message = i18n.createPage;
	if (showCreateDocButton) {
		message = i18n.createDoc;
	} else if (showCreateLivePageButton) {
		message = i18n.createLivePage;
	}

	return (
		<LinkButton href={creationHref} appearance={appearance} shouldFitContainer={false}>
			<FormattedMessage {...message} />
		</LinkButton>
	);
};
